import React, { Fragment } from 'react';
import '../about/css/director.css';
import bg1 from '../../images/banner/b3.jpg';

const Director = () => {
    return (
        <Fragment>
             
           <div className="About_Director">
                <h2>ABOUT DIRECTOR</h2>
               <div className="Director">
                   <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                       Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                       when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                       It has survived not only five centuries, but also the leap into electronic typesetting, 
                       remaining essentially unchanged.
                       Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                       Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                       when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                       It has survived not only five centuries, but also the leap into electronic typesetting, 
                       remaining essentially unchanged.</p>
            
                    <div className="Director_Photo">
                    <img src={bg1} alt='Harshitha developers and constructions Director' data-aos="fade-up"  data-aos-duration="1000" width="100%" height="100%" />
                    </div>
               </div>
                
           </div>
        </Fragment>
        
    )
}

export default Director;